var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIls08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "930px",
    height: "738px",
    viewBox: "0 0 930 738",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 2975508,
    transform: "translate(-732 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.76 32.5067C269.215 17.486 257.672 4.27349 241.794 0.430763C212.412 -1.91109 197.078 5.40273 181.886 19.7612C166.694 34.122 157.976 53.6525 149.509 72.6017C141.039 91.5485 132.043 111.012 116.487 124.997C89.9387 148.863 49.0009 152.615 23.158 177.215C-2.68729 201.816 -6.5698 243.833 9.86218 275.254C26.2966 306.675 59.9507 327.404 95.3601 333.934C106.871 336.056 118.713 336.833 130.322 335.294C164.462 330.775 193.531 306.105 209.159 276.019C224.791 245.934 228.464 211.095 226.624 177.385C225.729 160.956 223.733 143.705 230.643 128.711C244.34 98.9839 279.345 88.7636 278.439 51.3011C278.288 45.0784 277.024 38.6413 274.76 32.5067",
    transform: "translate(739.6172 78.163025)",
    id: "Fill-4",
    fill: "#64B6B8",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.075 33.7398C324.671 9.76528 289.755 -4.95691 262.258 1.53648C220.86 11.3137 219.527 56.8681 214.469 91.2407C210.585 117.631 201.872 144.83 181.83 162.625C170.278 172.884 155.833 179.243 141.811 185.82C106.227 202.51 71.2296 222.043 43.9985 250.217C16.7699 278.391 -2.07992 316.417 0.184087 355.365C0.752509 365.164 2.65854 374.958 6.63265 383.949C15.3138 403.609 33.2034 417.957 52.4329 427.823C79.4535 441.685 110.315 448.102 140.681 446.17C168.945 444.369 197.615 434.81 217.551 414.872C246.127 386.296 251.797 342.894 255.277 302.809C258.76 262.727 262.822 219.541 289.477 189.195C297.723 179.811 307.785 172.141 316.135 162.845C341.121 135.024 353.505 92.9905 347.158 56.2018C345.652 47.4816 342.872 40.063 339.075 33.7398",
    transform: "translate(1005.3711 214.94836)",
    id: "Fill-6",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#60BFC2",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.453 0.558719C50.9624 -4.57567 -1.3007 32.6797 0.0246873 88.3309C0.571142 111.283 11.8573 132.748 30.2331 146.516C53.3591 163.848 78.8579 161.104 105.807 156.646C140.265 150.943 174.495 156.653 201.937 179.521C217.456 192.455 235.151 223.429 260.029 212.747C269.695 208.597 275.955 197.867 280.89 189.14C287.218 177.953 290.59 165.973 286.316 153.438C277.784 128.412 251.128 117.562 229.396 106.873C213.056 98.8339 198.493 89.5213 190.339 72.6122C183.571 58.5787 178.459 45.0639 167.791 33.2845C149.259 12.8186 122.984 0.938779 95.4481 0.00177702C92.0591 -0.110568 92.0639 5.14094 95.4481 5.25568C120.46 6.10424 144.234 16.5164 161.696 34.4724C169.857 42.8648 175.851 52.4308 180.549 63.0653C185.052 73.2576 188.944 83.3758 196.813 91.553C212.099 107.441 234.104 113.281 252.585 124.291C262.855 130.41 272.993 138.58 278.74 149.274C287.086 164.802 281.123 179.691 272.099 193.335C268.192 199.241 264.279 205.172 257.441 207.877C247.928 211.64 238.104 207.141 230.772 201.039C220.646 192.615 213.173 181.598 202.716 173.433C186.423 160.709 166.753 152.468 146.242 149.738C120.777 146.351 97.1522 155.769 71.9266 155.494C46.6171 155.217 23.7787 139.744 12.4445 117.402C-1.36542 90.1786 5.72651 55.7462 25.7799 33.5115C45.3013 11.8673 74.9608 3.02552 103.453 5.81262C106.825 6.14009 106.801 0.886192 103.453 0.558719",
    transform: "translate(1167.5586 0)",
    id: "Fill-7",
    fill: "#60BFC2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.466 11.9761C296.386 -5.19598 260.214 -2.96205 229.97 12.6969C198.358 29.0647 180.709 56.3825 167.288 87.9223C152.318 123.097 138.185 165.281 95.5806 174.336C62.6427 181.339 32.9487 194.513 12.6472 222.409C-4.98223 246.629 -5.48371 279.316 19.4547 299.152C42.0359 317.114 75.2427 313.128 100.508 303.517C113.46 298.589 125.866 291.858 136.453 282.954C150.891 270.81 159.603 253.951 170.607 239.029C197.195 202.969 239.176 194.389 279.372 180.131C315.079 167.465 351.784 145.486 365.087 108.429C378.382 71.3898 358.953 32.0504 326.466 11.9761C323.554 10.1789 320.879 14.7136 323.777 16.506C356.438 36.6853 374.131 76.903 357.541 112.927C342.598 145.377 308.943 164.246 276.267 175.663C246.447 186.084 214.202 193.048 188.73 212.583C162.389 232.788 152.214 266.584 124.558 285.331C101.373 301.045 68.0088 312.016 40.0639 303.806C23.9075 299.061 10.6824 286.567 6.28294 270.29C1.93677 254.202 7.66868 238.161 17.2429 225.056C26.7226 212.079 39.749 201.521 53.759 193.606C68.784 185.122 84.1337 182.556 100.697 178.57C129.892 171.546 146.804 146.93 158.673 121.434C173.23 90.1586 182.671 56.0269 209.882 32.5778C240.921 5.82566 286.803 -4.60647 323.777 16.506C326.747 18.2005 329.431 13.6706 326.466 11.9761",
    transform: "translate(1282.8516 363.45813)",
    id: "Fill-8",
    fill: "#60BFC2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7749 1.03735C15.5639 -3.39953 -1.15529 6.42532 0.0628702 29.9567C0.682718 41.8852 5.68458 54.5259 16.3512 60.3308C39.5441 72.9481 50.9024 45.1414 48.5474 26.6396C46.7262 12.324 38.7519 3.83675 29.7749 1.03735",
    transform: "translate(1529.0625 567.659)",
    id: "Fill-9",
    fill: "#6F55FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4719 11.2347C22.4719 17.4395 17.4414 22.4719 11.2359 22.4719C5.03047 22.4719 0 17.4395 0 11.2347C0 5.02993 5.03047 0 11.2359 0C17.4414 0 22.4719 5.02993 22.4719 11.2347",
    transform: "translate(849.0469 449.43744)",
    id: "Fill-137",
    fill: "#6F55FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5178 9.77039C20.5178 15.1672 15.9232 19.5408 10.2589 19.5408C4.59222 19.5408 0 15.1672 0 9.77039C0 4.37354 4.59222 0 10.2589 0C15.9232 0 20.5178 4.37354 20.5178 9.77039",
    transform: "translate(734.7344 435.7589)",
    id: "Fill-140",
    fill: "#EE9E39",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6326 7.81631C15.6326 12.1321 12.1339 15.6326 7.81508 15.6326C3.49868 15.6326 0 12.1321 0 7.81631C0 3.49816 3.49868 0 7.81508 0C12.1339 0 15.6326 3.49816 15.6326 7.81631",
    transform: "translate(1266.2422 690.76587)",
    id: "Fill-145",
    fill: "#6F55FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7015 5.86223C12.7015 9.10126 9.85974 11.7245 6.35077 11.7245C2.84411 11.7245 0 9.10126 0 5.86223C0 2.62532 2.84411 0 6.35077 0C9.85974 0 12.7015 2.62532 12.7015 5.86223",
    transform: "translate(1204.6875 425.98853)",
    id: "Fill-157",
    fill: "#E46F62",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6326 8.79456C15.6326 13.6518 12.1328 17.5867 7.81522 17.5867C3.49984 17.5867 0 13.6518 0 8.79456C0 3.93977 3.49984 0 7.81522 0C12.1328 0 15.6326 3.93977 15.6326 8.79456",
    transform: "translate(1008.3047 643.868)",
    id: "Fill-158",
    fill: "#E46F62",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6326 7.8163C15.6326 12.1311 12.1329 15.6326 7.81508 15.6326C3.49724 15.6326 0 12.1311 0 7.8163C0 3.50153 3.49724 0 7.81508 0C12.1329 0 15.6326 3.50153 15.6326 7.8163",
    transform: "translate(1464.5781 17.58667)",
    id: "Fill-160",
    fill: "#FF9696",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.977051 0.977039L0.977051 0.977039",
    transform: "translate(881.28906 108.4512)",
    id: "Fill-176",
    fill: "#FCE3D6",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls08);
export default __webpack_public_path__ + "static/media/ils_08.6a91f84807bc99cf0a8efafdc0673e61.svg";
export { ForwardRef as ReactComponent };